import { defineMessages } from "locales/defineMessages";

export default defineMessages({
  vi: {
    "sysNav.centers": "Trung tâm",
    "sysNav.usersManagement": "Quản lý người dùng",
    "sysNav.faceCheckLogs": "Nhật ký nhận diện",
    "sysLayout.loadingCenter": "Đang tải thông tin trung tâm...",
    "sysLayout.centerOverview": "Tổng quan",
    "sysLayout.centerClasses": "Quản lý buổi học",
    "sysLayout.centerSessions": "Buổi học",
    "sysLayout.centerUsers": "Nhân sự & học viên",
    "centers.create.title": "Tạo trung tâm mới",
    "centers.create.subtitle":
      "Hoàn tất 2 bước, hệ thống sẽ tự tạo tài khoản quản lý và gửi mật khẩu về email.",
    "centers.create.centerInfo": "Thông tin trung tâm",
    "centers.create.managerInfo": "Thông tin quản lý trung tâm",
    "centers.create.sendEmail": "Gửi email thông tin đăng nhập cho quản lý",
    "centers.create.submit": "Tạo trung tâm",
    "centers.create.submitting": "Đang tạo...",
    "centers.create.error": "Tạo trung tâm thất bại",
    "centers.create.errorNameExists": "Tên trung tâm đã tồn tại",
    "centers.create.errorEmailExists": "Email quản lý đã được sử dụng",
    "centers.create.errorCodeExists": "Mã nhân viên đã được sử dụng",
    "centers.field.name": "Tên trung tâm",
    "centers.field.namePlaceholder": "VD: OmniSport Quận 1",
    "centers.field.code": "Mã trung tâm",
    "centers.field.codePlaceholder": "VD: OS01",
    "centers.field.codeHint":
      "Dùng để tạo tên đăng nhập tự động cho người dùng",
    "centers.field.address": "Địa chỉ",
    "centers.field.addressPlaceholder": "VD: 123 Nguyễn Huệ, Q1",
    "centers.field.phone": "Số điện thoại trung tâm",
    "centers.field.phonePlaceholder": "VD: 028 1234 5678",
    "centers.manager.fullName": "Họ tên",
    "centers.manager.fullNamePlaceholder": "Nguyễn Văn A",
    "centers.manager.password": "Mật khẩu",
    "centers.manager.passwordPlaceholder": "Để trống sẽ tạo mật khẩu tự động",
    "centers.title": "Quản lý trung tâm",
    "centers.subtitle":
      "Tạo và quản lý các trung tâm thể thao theo cùng một chuẩn giao diện và vận hành.",
    "centers.managerFilterPlaceholder": "Lọc theo tên quản lý...",
    "centers.includeManager": "Tải thông tin quản lý",
    "centers.emptyTitle": "Chưa có trung tâm nào",
    "centers.emptyDescription":
      "Tạo trung tâm đầu tiên để bắt đầu phân quyền, lớp học và người dùng theo từng cơ sở.",
    "centers.noAddress": "Chưa có địa chỉ",
    "centers.createdOn": "Tạo: {date}",
    "centers.managersCount": "Quản lý ({count})",
    "centers.classStatus.DRAFT": "Nháp",
    "centers.classStatus.ACTIVE": "Đang mở",
    "centers.classStatus.INACTIVE": "Tạm dừng",
    "centers.classStatus.COMPLETED": "Hoàn thành",
    "centers.classStatus.CANCELLED": "Đã hủy",
    "centers.detail.noDescription": "Chưa có mô tả",
    "centers.detail.classCode": "Mã lớp: {code}",
    "centers.detail.code": "Mã: {code}",
    "centers.detail.createdAt": "Tạo lúc: {date}",
    "centers.detail.loadError": "Không tải được dữ liệu trung tâm",
    "centers.detail.staffLoadError":
      "Không tải được danh sách nhân viên và học viên",
    "centers.detail.classesLoadError":
      "Không tải được danh sách lớp học của trung tâm",
    "centers.detail.updateError": "Cập nhật trung tâm thất bại",
    "centers.detail.updateSuccess": "Đã cập nhật trung tâm thành công",
    "centers.detail.notFound": "Không tìm thấy trung tâm",
    "centers.detail.backToList": "Quay lại danh sách",
    "centers.field.addressInput": "Nhập địa chỉ trung tâm",
    "centers.detail.staffAndStudents": "Nhân viên và học viên",
    "centers.detail.staffSearchPlaceholder": "Tìm theo tên, email, vai trò...",
    "centers.detail.staffLoading": "Đang tải danh sách...",
    "centers.detail.staffEmpty":
      "Không có nhân viên hoặc học viên thuộc trung tâm này.",
    "centers.detail.classesTitle": "Danh sách lớp học của trung tâm",
    "centers.detail.classesLoading": "Đang tải danh sách lớp học...",
    "centers.detail.classesEmpty": "Trung tâm này chưa có lớp học nào.",
    "userSessions.loadAssignedError":
      "Không tải được dữ liệu học viên thuộc lớp bạn phụ trách.",
    "userSessions.user": "Người dùng",
    "userSessions.usersLoading": "Đang tải danh sách...",
    "userSessions.noMatch": "Không tìm thấy",
    "userSessions.noEmail": "Chưa có email",
    "userSessions.showingLimited":
      "Hiển thị {shown}/{total} kết quả. Nhập thêm để lọc.",
    "userSessions.month": "Tháng",
    "userSessions.resultCount": "Kết quả ({count} buổi học)",
    "userSessions.empty": "Không có buổi học nào",
    "userSessions.colTitle": "Tiêu đề",
    "userSessions.colClass": "Lớp",
    "userSessions.colStart": "Bắt đầu",
    "userSessions.colEnd": "Kết thúc",
    "userSessions.colStatus": "Trạng thái",
    "userSessions.colVenue": "Địa điểm",
    "userSessions.unscheduled": "Chưa xếp lịch",
    "userSessions.export.monthRequired": "Vui lòng chọn tháng",
    "userSessions.export.studentRequired": "Vui lòng chọn ít nhất một học viên",
    "userSessions.export.failed": "Xuất Excel thất bại",
    "userSessions.export.month": "Tháng xuất",
    "userSessions.export.selectedCount": "Chọn cụ thể học viên ({count})",
    "userSessions.export.noStudents": "Không có học viên",
    "userSessions.export.showingLimited":
      "Hiển thị {shown}/{total}. Nhập thêm để lọc.",
    "centerSettings.loadError": "Không tải được thông tin trung tâm",
    "centerSettings.updateSuccess": "Đã cập nhật thông tin trung tâm",
    "centerSettings.updateError": "Cập nhật thất bại",
    "centerSettings.noCenter": "Bạn chưa thuộc trung tâm nào.",
    "centerSettings.subtitle":
      "Cập nhật thông tin cơ bản cho trung tâm của bạn.",
    "userSettings.loading": "Đang tải hồ sơ...",
    "userSettings.avatarUpdated": "Đã cập nhật ảnh đại diện",
    "userSettings.avatarUploadError": "Không thể tải ảnh",
    "userSettings.usernameNoSpaces":
      "Tên đăng nhập không được chứa khoảng trắng",
    "userSettings.usernameInvalidChars":
      "Tên đăng nhập chỉ cho phép chữ, số, dấu chấm, gạch dưới, gạch ngang",
    "userSettings.usernameTooShort": "Tên đăng nhập phải có ít nhất 3 ký tự",
    "userSettings.emailInvalid": "Email không hợp lệ",
    "userSettings.saveSuccess": "Đã lưu thông tin hồ sơ",
    "userSettings.saveError": "Không thể lưu hồ sơ",
    "userSettings.username": "Tên đăng nhập",
    "userSettings.personalInfoDesc":
      "Thông tin nền tảng dùng để hiển thị hồ sơ và đồng bộ trong toàn hệ thống.",
    "userSettings.physicalInfoDesc": "Dữ liệu thể chất và ghi chú cá nhân.",
    "userSettings.physicalInfoDescStaff":
      "Dữ liệu thể chất và ghi chú cá nhân được gom về cùng một cụm hiển thị thống nhất.",
    "userSettings.additionalInfo": "Thông tin bổ sung",
    "userSettings.additionalInfoDesc": "Thông tin phụ huynh và ghi chú y tế.",
    "userSettings.parentPhone": "SĐT phụ huynh",
    "userSettings.medicalNote": "Ghi chú y tế",
  },
  en: {
    "sysNav.centers": "Centers",
    "sysNav.usersManagement": "User management",
    "sysNav.faceCheckLogs": "Face recognition logs",
    "sysLayout.loadingCenter": "Loading center info...",
    "sysLayout.centerOverview": "Overview",
    "sysLayout.centerClasses": "Session management",
    "sysLayout.centerSessions": "Sessions",
    "sysLayout.centerUsers": "Staff & students",
    "centers.create.title": "Create new center",
    "centers.create.subtitle":
      "Complete 2 steps and the system will create the manager account and email the password.",
    "centers.create.centerInfo": "Center information",
    "centers.create.managerInfo": "Center manager information",
    "centers.create.sendEmail": "Email login details to the manager",
    "centers.create.submit": "Create center",
    "centers.create.submitting": "Creating...",
    "centers.create.error": "Failed to create center",
    "centers.create.errorNameExists": "A center with this name already exists",
    "centers.create.errorEmailExists": "This manager email is already in use",
    "centers.create.errorCodeExists": "This staff code is already in use",
    "centers.field.name": "Center name",
    "centers.field.namePlaceholder": "e.g. OmniSport District 1",
    "centers.field.code": "Center code",
    "centers.field.codePlaceholder": "e.g. OS01",
    "centers.field.codeHint": "Used to auto-generate usernames for users",
    "centers.field.address": "Address",
    "centers.field.addressPlaceholder": "e.g. 123 Nguyen Hue, District 1",
    "centers.field.phone": "Center phone number",
    "centers.field.phonePlaceholder": "e.g. 028 1234 5678",
    "centers.manager.fullName": "Full name",
    "centers.manager.fullNamePlaceholder": "John Smith",
    "centers.manager.password": "Password",
    "centers.manager.passwordPlaceholder":
      "Leave blank to auto-generate a password",
    "centers.title": "Center management",
    "centers.subtitle":
      "Create and manage sports centers with a consistent interface and operations.",
    "centers.managerFilterPlaceholder": "Filter by manager name...",
    "centers.includeManager": "Load manager info",
    "centers.emptyTitle": "No centers yet",
    "centers.emptyDescription":
      "Create your first center to start setting up permissions, classes and users per location.",
    "centers.noAddress": "No address yet",
    "centers.createdOn": "Created: {date}",
    "centers.managersCount": "Managers ({count})",
    "centers.classStatus.DRAFT": "Draft",
    "centers.classStatus.ACTIVE": "Open",
    "centers.classStatus.INACTIVE": "Paused",
    "centers.classStatus.COMPLETED": "Completed",
    "centers.classStatus.CANCELLED": "Cancelled",
    "centers.detail.noDescription": "No description yet",
    "centers.detail.classCode": "Class code: {code}",
    "centers.detail.code": "Code: {code}",
    "centers.detail.createdAt": "Created on: {date}",
    "centers.detail.loadError": "Failed to load center data",
    "centers.detail.staffLoadError": "Failed to load staff and students",
    "centers.detail.classesLoadError": "Failed to load the center's classes",
    "centers.detail.updateError": "Failed to update center",
    "centers.detail.updateSuccess": "Center updated successfully",
    "centers.detail.notFound": "Center not found",
    "centers.detail.backToList": "Back to list",
    "centers.field.addressInput": "Enter center address",
    "centers.detail.staffAndStudents": "Staff and students",
    "centers.detail.staffSearchPlaceholder": "Search by name, email, role...",
    "centers.detail.staffLoading": "Loading list...",
    "centers.detail.staffEmpty": "This center has no staff or students.",
    "centers.detail.classesTitle": "Center classes",
    "centers.detail.classesLoading": "Loading classes...",
    "centers.detail.classesEmpty": "This center has no classes yet.",
    "userSessions.loadAssignedError":
      "Failed to load students in your assigned classes.",
    "userSessions.user": "User",
    "userSessions.usersLoading": "Loading list...",
    "userSessions.noMatch": "No matches",
    "userSessions.noEmail": "No email",
    "userSessions.showingLimited":
      "Showing {shown}/{total} results. Keep typing to narrow down.",
    "userSessions.month": "Month",
    "userSessions.resultCount": "Results ({count} sessions)",
    "userSessions.empty": "No sessions",
    "userSessions.colTitle": "Title",
    "userSessions.colClass": "Class",
    "userSessions.colStart": "Start",
    "userSessions.colEnd": "End",
    "userSessions.colStatus": "Status",
    "userSessions.colVenue": "Venue",
    "userSessions.unscheduled": "Not scheduled",
    "userSessions.export.monthRequired": "Please select a month",
    "userSessions.export.studentRequired": "Please select at least one student",
    "userSessions.export.failed": "Excel export failed",
    "userSessions.export.month": "Export month",
    "userSessions.export.selectedCount": "Select specific students ({count})",
    "userSessions.export.noStudents": "No students",
    "userSessions.export.showingLimited":
      "Showing {shown}/{total}. Keep typing to narrow down.",
    "centerSettings.loadError": "Failed to load center information",
    "centerSettings.updateSuccess": "Center information updated",
    "centerSettings.updateError": "Update failed",
    "centerSettings.noCenter": "You don't belong to any center yet.",
    "centerSettings.subtitle": "Update your center's basic information.",
    "userSettings.loading": "Loading profile...",
    "userSettings.avatarUpdated": "Profile photo updated",
    "userSettings.avatarUploadError": "Couldn't upload photo",
    "userSettings.usernameNoSpaces": "Username can't contain spaces",
    "userSettings.usernameInvalidChars":
      "Username may only contain letters, numbers, dots, underscores and hyphens",
    "userSettings.usernameTooShort": "Username must be at least 3 characters",
    "userSettings.emailInvalid": "Invalid email",
    "userSettings.saveSuccess": "Profile saved",
    "userSettings.saveError": "Couldn't save profile",
    "userSettings.username": "Username",
    "userSettings.personalInfoDesc":
      "Core information used to display your profile and sync it across the system.",
    "userSettings.physicalInfoDesc": "Physical data and personal notes.",
    "userSettings.physicalInfoDescStaff":
      "Physical data and personal notes, grouped in one place.",
    "userSettings.additionalInfo": "Additional information",
    "userSettings.additionalInfoDesc": "Parent contact and medical notes.",
    "userSettings.parentPhone": "Parent's phone",
    "userSettings.medicalNote": "Medical notes",
  },
});
